module.exports = __webpack_public_path__ + "img/icon_chart.0d2336fc.svg";